import { getDeeplinkValues } from './utils/deeplinkValues';
import type { LaunchOptionPromptDataV2 } from 'owa-bizchat-types/lib/types';

/**
 * This generates the deeplink payload for subPageId flow.
 *
 * BizChat retrieves subPageId via getAppContext call to HubSDK, and expects
 * it to be a JSON string. This function constructs that JSON string, and if we
 * already have an encoded deeplink (from initial routing in `mailCopilotRouteHandler`),
 * it base64 decodes and returns that instead.
 */
export const getBizChatSubPageDeepLink = (): string | null => {
    const values = getDeeplinkValues();
    if (!values) {
        return null;
    }
    const { encodedDeeplink, id, scenario, conversationId, chatType } = values;

    // If we have a base64-encoded deeplink provided by routing we always use that instead of creating our own
    if (encodedDeeplink) {
        // BizChat expects the decoded deeplink JSON string
        return atob(encodedDeeplink);
    }

    if (!id && !conversationId) {
        return null;
    }

    // DO NOT rollout to MSIT/WW with 'default' deeplink scenario.
    // Onboard a new scenario: https://office.visualstudio.com/Office/_wiki/wikis/1JS/118816/BizChat-Deep-Linking-for-Handin-scenarios?anchor=adding-a-new-scenario
    const scenarioValue =
        scenario ?? (conversationId ? 'default' : id ? 'launchcopilotextension' : '');

    const payload: LaunchOptionPromptDataV2 = {
        id, // required for prompt handin and agent handin scenarios
        scenario: scenarioValue,
        version: 1,
        properties: {
            clickTimestamp: new Date().toISOString(),
        },
        chatType,
        conversationId,
    };

    return JSON.stringify(payload);
};
